import { usersApi } from 'entities/users/index';
import { toast } from 'react-toastify';

const usersMPApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    createUsersMP: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: 'account/admin/users/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error) => {
        if (error) {
          if (error.status === 422) {
            toast.error('Исправьте ошибки', {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            toast.error('Возникла непредвиденная ошибка. Пожалуйста, попробуйте еще раз', {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        } else {
          toast.success('Пользователь МП создан', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'Users' }];
      },
    }),
  }),
});

export const { useCreateUsersMPMutation } = usersMPApi;
